module.exports = __webpack_public_path__ + "static/media/Florocense.26430edb.jpg";